export default __webpack_public_path__ + "static/media/verify-on-submit.5e7f3281.gif";